import { render, staticRenderFns } from "./MeasuresEdit.vue?vue&type=template&id=3fa8d442&"
import script from "./MeasuresEdit.vue?vue&type=script&lang=js&"
export * from "./MeasuresEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports